import React from 'react';
import FormLabel from './FormLabel';
import FormInput from './FormInput';

/**
 * Wspolne elementy formularzy DFG (ZAWMRP i ZAUMDE).
 */

export const DfgSection = ({ title, hint, action, children }) => (
  <div className="mt-6">
    <div className="flex justify-between items-center mb-2">
      <div>
        <h3 className="text-sm font-semibold text-[var(--electric-blue)]">{title}</h3>
        {hint && <p className="text-xs text-gray-500 mt-0.5">{hint}</p>}
      </div>
      {action}
    </div>
    {children}
  </div>
);

export const DfgField = ({ id, label, value, onChange, type = 'text', placeholder = '', className = '', ...props }) => (
  <div className={className}>
    <FormLabel htmlFor={id}>{label}</FormLabel>
    <FormInput
      id={id}
      type={type}
      value={value ?? ''}
      onChange={onChange}
      placeholder={placeholder}
      className="mt-1"
      {...props}
    />
  </div>
);

export const DfgSelect = ({ id, label, value, onChange, options, className = '' }) => (
  <div className={className}>
    <FormLabel htmlFor={id}>{label}</FormLabel>
    <select
      id={id}
      value={value ?? ''}
      onChange={onChange}
      className="w-full px-3 py-2 border rounded-md text-[var(--electric-blue)] mt-1"
    >
      {options.map((opt) => (
        <option key={opt} value={opt}>{opt}</option>
      ))}
    </select>
  </div>
);

export const RowCard = ({ children, onRemove, removable = true }) => (
  <div className="relative border rounded-md p-3 mb-2 bg-gray-50">
    {removable && (
      <button
        type="button"
        onClick={onRemove}
        title="Usuń"
        className="absolute top-2 right-2 text-[var(--maroon)] hover:opacity-70 p-1"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    )}
    {children}
  </div>
);

export const AddRowButton = ({ onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className="text-sm text-[var(--maroon)] hover:underline"
  >
    + {children}
  </button>
);

export const DfgErrors = ({ errors }) => {
  if (!errors || errors.length === 0) return null;
  return (
    <div className="mt-4 border border-red-300 bg-red-50 rounded-md p-3">
      <p className="text-sm font-semibold text-red-700 mb-1">
        Uzupełnij brakujące dane ({errors.length}):
      </p>
      <ul className="list-disc list-inside text-sm text-red-700 space-y-0.5">
        {errors.map((err, i) => (
          <li key={i}>{err}</li>
        ))}
      </ul>
    </div>
  );
};

export const DfgPreview = ({ open, onToggle, json }) => (
  <div className="mt-4">
    <button
      type="button"
      onClick={onToggle}
      className="text-sm text-[var(--maroon)] hover:underline"
    >
      {open ? 'Ukryj podgląd JSON' : 'Pokaż podgląd JSON'}
    </button>
    {open && (
      <pre className="mt-2 p-3 bg-gray-900 text-gray-100 text-xs rounded-md overflow-auto max-h-72">
        {json}
      </pre>
    )}
  </div>
);
